/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/to_long.json`.

import type { DefinitionDocs } from '../../definition_types';

const docs: DefinitionDocs = {
  description: 'Converts the input value to a long.\nIf the input parameter is of a date type, its value will be interpreted as milliseconds\nsince the Unix epoch, converted to long.\nBoolean `true` will be converted to long `1`, `false` to `0`.',
  examples: [
    'ROW str1 = "2147483648", str2 = "2147483648.2", str3 = "foo"\n| EVAL long1 = TO_LONG(str1), long2 = TO_LONG(str2), long3 = TO_LONG(str3)',
    'ROW str1 = "0x32", str2 = "31"\n| EVAL long1 = TO_LONG(str1, 16), long2 = TO_LONG(str2, 13)\n| KEEP str1, long1, str2, long2',
    'ROW str1 = "Hazelnut"\n| EVAL long1 = TO_LONG(str1, 36), fail1 = TO_LONG(str1, 10)',
  ],
  params: {
    field: 'Input value. The input can be a single- or multi-valued column or an expression.',
    base: '(Optional) Radix or base used to convert the input value.When a base is specified the input type must be `keyword` or `text`.',
  },
};

export default docs;
